import { render, staticRenderFns } from "./LaporanBiayaTrukById.vue?vue&type=template&id=268721db&scoped=true&"
import script from "./LaporanBiayaTrukById.vue?vue&type=script&lang=js&"
export * from "./LaporanBiayaTrukById.vue?vue&type=script&lang=js&"
import style0 from "./LaporanBiayaTrukById.vue?vue&type=style&index=0&id=268721db&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268721db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
